"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKDrawerContainer = exports.GKDrawerContext = exports.GKDrawerDefaultContext = void 0;
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
// @TODO: fix jsx-a11y
var React = __importStar(require("react"));
var common_1 = require("../../../common");
var context_1 = require("../../../common/context");
var components_1 = require("../../../components");
require("./GKDrawerContainer.css");
exports.GKDrawerDefaultContext = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toggleDrawer: function (drawerId, open) {
        return;
    },
};
/** @deprecated in favor of GKLeftPane within GKLayoutShell. */
exports.GKDrawerContext = React.createContext(exports.GKDrawerDefaultContext);
/** @deprecated in favor of GKLeftPane within GKLayoutShell */
var GKDrawerContainer = /** @class */ (function (_super) {
    __extends(GKDrawerContainer, _super);
    function GKDrawerContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.drawerRefs = {};
        // Toggles child drawers.
        // This function is passed down via GKDrawerContext to ancestors so that drawers can toggle other drawers (and themselves, without a ref, if desired).
        _this.toggleDrawer = function (drawerId, open) {
            _this.drawerRefs[drawerId].toggle(open !== undefined && typeof open === "boolean" ? open : undefined);
        };
        // Expands/contracts the drawer
        _this.toggleExpand = function () {
            _this.setState({
                drawerContainerIsExpanded: !_this.state.drawerContainerIsExpanded,
            });
        };
        // Opens and closes the drawer container itself (on mobile).
        _this.toggleOpen = function () {
            _this.toggleDrawerContainerOpenState();
        };
        // Toggles the drawerContainerIsOpen state (reused, hence a function)
        _this.toggleDrawerContainerOpenState = function () {
            _this.setState({ drawerContainerIsOpen: !_this.state.drawerContainerIsOpen });
        };
        // Sets up our drawer children to be rendered.
        // Adds a key and a ref so that drawerContainer can toggle its children.
        // If `openDrawers` prop is passed, it gets to decide whether a drawer is open. Otherwise we fallback to the `open` prop on the drawer itself.
        _this.renderChildren = function () {
            return React.Children.map(_this.props.children, function (child, i) {
                return React.cloneElement(child, {
                    key: "drawer-" + i,
                    open: _this.props.openDrawers
                        ? _this.props.openDrawers.indexOf(child.props.id) >= 0
                        : child.props.open,
                    ref: function (ref) { return (_this.drawerRefs[child.props.id] = ref); },
                });
            });
        };
        // Determines how tall an "open" drawer container should be.
        _this.getMobileHeight = function () {
            var _a;
            var mobileHeight = _this.props.mobileHeight || 0.5;
            var _b = _this.context.viewportHeight, viewportHeight = _b === void 0 ? 0 : _b;
            // Return early if possible to skip extra calculations.
            if (mobileHeight > 1) {
                return mobileHeight;
            }
            // Using shell here instead of viewport prevents problems with nested shells.
            var shell = (_a = _this.drawerContainerDiv) === null || _a === void 0 ? void 0 : _a.closest(".gk-shell");
            var navbar = shell === null || shell === void 0 ? void 0 : shell.querySelector(".gk-navbar");
            var availHeight = ((shell === null || shell === void 0 ? void 0 : shell.clientHeight) || viewportHeight) - ((navbar === null || navbar === void 0 ? void 0 : navbar.clientHeight) || 0);
            return availHeight * mobileHeight;
        };
        _this.state = {
            drawerContainerIsExpanded: _this.props.size === "lg",
            drawerContainerIsOpen: _this.props.mobileInitialOpen || false,
        };
        return _this;
    }
    GKDrawerContainer.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        // Update the size state.
        if (this.props.size !== prevProps.size ||
            this.props.expandable !== prevProps.expandable) {
            this.setState({ drawerContainerIsExpanded: this.props.size === "lg" });
        }
        // Call the toggle method on each drawer if the container's list of open drawers has changed.
        if (this.props.openDrawers !== prevProps.openDrawers) {
            Object.keys(this.drawerRefs).forEach(function (drawer) {
                _this.drawerRefs[drawer].toggle(_this.props.openDrawers && _this.props.openDrawers.indexOf(drawer) >= 0
                    ? true
                    : false);
            });
        }
    };
    GKDrawerContainer.prototype.render = function () {
        var _this = this;
        var _a = this.props, expandable = _a.expandable, 
        /* eslint-disable @typescript-eslint/no-unused-vars */
        mobileHeight = _a.mobileHeight, mobileInitialOpen = _a.mobileInitialOpen, openDrawers = _a.openDrawers, 
        /* eslint-enable @typescript-eslint/no-unused-vars */
        size = _a.size, otherProps = __rest(_a, ["expandable", "mobileHeight", "mobileInitialOpen", "openDrawers", "size"]);
        var _b = this.state, drawerContainerIsOpen = _b.drawerContainerIsOpen, drawerContainerIsExpanded = _b.drawerContainerIsExpanded;
        var isTabletSized = this.context.isTabletSized;
        return (React.createElement(exports.GKDrawerContext.Provider, { value: { toggleDrawer: this.toggleDrawer } },
            React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(otherProps, {
                _gkComponentName: "gk-drawer-container",
                className: [
                    "d-flex",
                    "flex-column",
                    drawerContainerIsOpen ? "open" : "",
                    expandable ? "expandable" : "",
                    drawerContainerIsExpanded ? "expanded" : "",
                    size ? "gk-drawer-size-" + size : "gk-drawer-size-sm",
                ]
                    .filter(function (x) { return x; })
                    .join(" "),
                style: {
                    height: isTabletSized
                        ? drawerContainerIsOpen
                            ? this.getMobileHeight()
                            : 32
                        : "auto",
                },
            }), { ref: function (ref) {
                    return (_this.drawerContainerDiv = ref);
                } }),
                React.createElement("div", { className: "drawer-topbar", onClick: this.toggleOpen },
                    React.createElement(components_1.GKIcon, { name: this.state.drawerContainerIsOpen
                            ? components_1.GKIconName.KeyboardArrowDown
                            : components_1.GKIconName.KeyboardArrowUp })),
                expandable && (React.createElement("div", { className: "drawer-expand-collapse hidden-xs d-none d-md-block", onClick: this.toggleExpand },
                    React.createElement(components_1.GKIcon, { name: this.state.drawerContainerIsExpanded
                            ? components_1.GKIconName.KeyboardArrowLeft
                            : components_1.GKIconName.KeyboardArrowRight }))),
                this.renderChildren())));
    };
    GKDrawerContainer.contextType = context_1.WindowSizeContext;
    return GKDrawerContainer;
}(common_1.GKPureComponent));
exports.GKDrawerContainer = GKDrawerContainer;
